/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportPurchase$Pdf } from '../fn/purchase/export-purchase-pdf';
import { ExportPurchase$Pdf$Params } from '../fn/purchase/export-purchase-pdf';
import { exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet } from '../fn/purchase/export-purchase-vnd-openxmlformats-officedocument-spreadsheetml-sheet';
import { ExportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Params } from '../fn/purchase/export-purchase-vnd-openxmlformats-officedocument-spreadsheetml-sheet';


/**
 * Purchase export endpoints. PRODUCT_ADMIN may only access their own purchases; EASYLOT_ADMIN has unrestricted access.
 */
@Injectable({ providedIn: 'root' })
export class PurchaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportPurchase()` */
  static readonly ExportPurchasePath = '/purchase/{id}/export';

  /**
   * Export purchase details.
   *
   * Downloads purchase details as EXCEL or PDF. EASYLOT_ADMIN can access any purchase; PRODUCT_ADMIN only their own (as buyer or seller). The {id} path parameter accepts either a UUID or a purchase code (e.g. A1875).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params: ExportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export purchase details.
   *
   * Downloads purchase details as EXCEL or PDF. EASYLOT_ADMIN can access any purchase; PRODUCT_ADMIN only their own (as buyer or seller). The {id} path parameter accepts either a UUID or a purchase code (e.g. A1875).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(params: ExportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Params, context?: HttpContext): Observable<string> {
    const resp = this.exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Export purchase details.
   *
   * Downloads purchase details as EXCEL or PDF. EASYLOT_ADMIN can access any purchase; PRODUCT_ADMIN only their own (as buyer or seller). The {id} path parameter accepts either a UUID or a purchase code (e.g. A1875).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPurchase$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPurchase$Pdf$Response(params: ExportPurchase$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = exportPurchase$Pdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export purchase details.
   *
   * Downloads purchase details as EXCEL or PDF. EASYLOT_ADMIN can access any purchase; PRODUCT_ADMIN only their own (as buyer or seller). The {id} path parameter accepts either a UUID or a purchase code (e.g. A1875).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPurchase$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPurchase$Pdf(params: ExportPurchase$Pdf$Params, context?: HttpContext): Observable<string> {
    const resp = this.exportPurchase$Pdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
